import { isEmpty, kebabCase } from 'lodash/fp';
import React from 'react';

import { ACCORDION_INITIAL_ITEMS_COUNT } from '../../../../../ahm-constants/ui';
import { ImageType } from '../../../../../types/image';
import { PortableTextType } from '../../../../../types/sanityInternal';
import { Question } from '../../../../../types/__codegen__/sanity/graphql';
import AccordionSection from '../../../../../components/sections/accordion-section';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';

type CommonQuestionsSectionProps = {
  image?: ImageType | null;
  questions?: Question[];
  summary?: PortableTextType;
  title?: string;
};

const CommonQuestionsSection = ({ image, questions, summary, title }: CommonQuestionsSectionProps) => {
  if (isEmpty(questions)) {
    return null;
  }

  return (
    <AccordionSection
      // @ts-expect-error - Automatic, Please fix when editing this file
      accordionId={`explained-term-common-questions-${kebabCase(title)}`}
      image={image}
      initialVisible={ACCORDION_INITIAL_ITEMS_COUNT}
      items={getFormattedQuestionForAccordion(questions)}
      // @ts-expect-error - Automatic, Please fix when editing this file
      summary={summary}
      title={title}
      withBorder
    />
  );
};

CommonQuestionsSection.defaultProps = {
  image: {},
  questions: [],
  summary: {},
  title: '',
};

export default CommonQuestionsSection;
